import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CUSTOM_ICON_TYPE } from '@shared/models';

export enum ORDER_STATUS {
  WAITING = 'WAITING',
  CANCELLED = 'CANCELLED',
  READY = 'READY',
  READY_RECIEVE = 'READY_RECIEVE',
  DELIVERY = 'DELIVERY',
  CLOSED = 'CLOSED',
  PAPERWORK = 'PAPERWORK',
  ORDER_PACKAGE = 'ORDER_PACKAGE',
  SUBORDER_PROCESSING = 'SUBORDER_PROCESSING',
  STORAGE_ARRIVE = 'STORAGE_ARRIVE',
  SHOP_ARRIVE = 'SHOP_ARRIVE',
  PARTLY_SHIPPED = 'PARTLY_SHIPPED',
  PROCESSING = 'PROCESSING',
}

@Component({
  selector: 'sd-order-status-label',
  templateUrl: './order-status-label.component.html',
  styleUrls: ['./order-status-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
})
export class OrderStatusLabelComponent {
  @Input() text: string;
  @Input() code: ORDER_STATUS;
  public iconType = CUSTOM_ICON_TYPE;
}
